import React from "react";
import cartIcon from "@/assets/top/cart-large-minimalistic-svgrepo-com.svg";
import * as styles from "./shoppingCart.css.ts";

const ShoppingCart: React.FC = () => {
  return (
    <div className={styles.cartContainer}>
      <a
        href="https://kitchen-muku.stores.jp"
        className={styles.cartLink}
        aria-label="オンラインストアへ"
      >
        <span className={styles.cartBadge}>
          <img src={cartIcon} alt="" className={styles.cartIcon} />
        </span>
      </a>
    </div>
  );
};

export default ShoppingCart;
